module.exports = __webpack_public_path__ + "img/Comic03-2.5b779785.png";